var map = {
	"./any_0.png": 49,
	"./bayonetta_0.png": 50,
	"./bowser_0.png": 51,
	"./bowserjr_0.png": 52,
	"./captainfalcon_0.png": 53,
	"./charizard_0.png": 54,
	"./cloud_0.png": 55,
	"./corrin_0.png": 56,
	"./darkpit_0.png": 57,
	"./diddykong_0.png": 58,
	"./donkeykong_0.png": 59,
	"./drmario_0.png": 60,
	"./duckhunt_0.png": 61,
	"./falco_0.png": 62,
	"./fox_0.png": 63,
	"./ganondorf_0.png": 64,
	"./greninja_0.png": 65,
	"./ike_0.png": 66,
	"./jigglypuff_0.png": 67,
	"./kingdedede_0.png": 68,
	"./kirby_0.png": 69,
	"./link_0.png": 70,
	"./littlemac_0.png": 71,
	"./lucario_0.png": 72,
	"./lucas_0.png": 73,
	"./lucina_0.png": 74,
	"./luigi_0.png": 75,
	"./mario_0.png": 76,
	"./marth_0.png": 77,
	"./megaman_0.png": 78,
	"./metaknight_0.png": 79,
	"./mewtwo_0.png": 80,
	"./mrgameandwatch_0.png": 81,
	"./ness_0.png": 82,
	"./olimar_0.png": 83,
	"./pacman_0.png": 84,
	"./palutena_0.png": 85,
	"./peach_0.png": 86,
	"./pikachu_0.png": 87,
	"./pit_0.png": 88,
	"./rob_0.png": 89,
	"./robin_0.png": 90,
	"./rosalina_0.png": 91,
	"./roy_0.png": 92,
	"./ryu_0.png": 93,
	"./samus_0.png": 94,
	"./sheik_0.png": 95,
	"./shulk_0.png": 96,
	"./sonic_0.png": 97,
	"./toonlink_0.png": 98,
	"./villager_0.png": 99,
	"./wario_0.png": 100,
	"./wiifittrainer_0.png": 101,
	"./yoshi_0.png": 102,
	"./zelda_0.png": 103,
	"./zerosuitsamus_0.png": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;